import { Col } from 'antd'
import dayjs from 'dayjs'

import { EpidemiologyCaseForm058E_SymptomsSection } from 'src/api/requests'
import { Text } from 'src/components'
import { dayMonthYearFormatWithDot } from 'src/libs'
import { useLocales } from 'src/locales'

type Props = {
  symptoms: EpidemiologyCaseForm058E_SymptomsSection
}

export const HospitalizationSymptomsDetailsCard = ({ symptoms }: Props) => {
  const { t } = useLocales()

  return (
    <>
      <Col span={24}>
        <Text>
          {`10. ${t('epidemiology.hospitalization')}`}:{' '}
          <Text weight={400}>
            {t(
              `epidemiology.symptoms.general.${symptoms.hospitalization?.status}`
            )}
          </Text>
        </Text>
      </Col>

      {symptoms.hospitalization?.status === 'yes' && (
        <>
          {symptoms.hospitalization.hospitalInstitution?.title?.value && (
            <Col span={12}>
              <Text>
                {t('epidemiology.symptoms.hospitalization.title')}:{' '}
                <Text weight={400}>
                  {symptoms.hospitalization.hospitalInstitution.title.value}
                </Text>
              </Text>
            </Col>
          )}

          {symptoms.hospitalization.hospitalInstitution?.hospitalizationDate
            ?.value && (
            <Col span={12}>
              <Text>
                {t('epidemiology.symptoms.hospitalization.hospitalizationDate')}
                :{' '}
                <Text weight={400}>
                  {dayjs(
                    symptoms.hospitalization.hospitalInstitution
                      .hospitalizationDate.value
                  ).format(dayMonthYearFormatWithDot)}
                </Text>
              </Text>
            </Col>
          )}
        </>
      )}
    </>
  )
}
